import { Component, OnInit } from '@angular/core';
import { emptyInvoicingService, IInvoicingService } from '../../../model/invoicing-service';
import { InvoicingServiceService } from '../../../services/invoicing-service.service';
import { Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { emptyPerson, IPerson } from '../../../model/person';
import { SpinnerService } from '../../../services/spinner.service';
import { IHttpErrorsResponse } from '../../../model/http-errors-response';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MyInvoicingServicesService } from "../../../services/my-invoicing-services.service";

declare const afirma: any;

@Component({
  selector: 'app-inv-invoicing-service',
  templateUrl: './inv-invoicing-service.component.html',
  styleUrls: ['./inv-invoicing-service.component.css']
})
export class InvInvoicingServiceComponent implements OnInit {

  /**
   *
   * @type {boolean}
   */
  renderNewInvoicingService: boolean = null;

  /**
   * My InvoicingServices
   *
   * @type {IInvoicingService[]}
   */
  myInvoicingServices: IInvoicingService[] = [];

  /**
   *
   * @type {IInvoicingService}
   */
  invoicingService: IInvoicingService = emptyInvoicingService;

  /**
   *
   * @type {boolean}
   */
  isAcceptedUseConditions: boolean = false;

  /**
   *
   * @type {string}
   * Formulario firma en cliente
   */
  xml: string;

  /**
   *
   * @type {IPerson}
   */
  person: IPerson = emptyPerson;

  /**
   *
   * @type {IHttpErrorsResponse}
   */
  private errors: IHttpErrorsResponse;

  /**
   *
   * @param {MyInvoicingServicesService} myInvoicingServicesService
   * @param {InvoicingServiceService} invoicingServiceService
   * @param {Router} router
   * @param {LoginService} loginService
   * @param {ToastsManager} toastr
   * @param {TranslateService} translate
   * @param {SpinnerService} spinnerService
   */
  constructor(private myInvoicingServicesService: MyInvoicingServicesService,
              private invoicingServiceService: InvoicingServiceService,
              private router: Router,
              private loginService: LoginService,
              private toastr: ToastsManager,
              private translate: TranslateService,
              private spinnerService: SpinnerService) {
  }

  ngOnInit() {

    this.person = this.loginService.getPerson();
    this.myInvoicingServicesService.myInvoicingService$
      .subscribe(invoicingService => {
        if (invoicingService.identifier) {
          this.router.navigate(['empresas/' + invoicingService.identifier + '/plataformas']).then();
        }
      });

    this.myInvoicingServicesService.myInvoicingServices$
      .subscribe(invoicingServices => {
        this.myInvoicingServices = invoicingServices;
        this.renderNewInvoicingService = this.myInvoicingServices.length !== 0;
      });
  }


  /**
   * Method invoked when the new invoicing services button is clicked
   * to show the creation form of invoicing sevices
   */
  createInvoicingServiceClicked() {
    this.renderNewInvoicingService = !this.renderNewInvoicingService;
  }

  /**
   * Save the invoicing service
   */
  saveInvoicingService() {
    this.errors = null;
    this.invoicingServiceService.validateInvoicingService(this.invoicingService)
      .subscribe(
        result => {
          afirma.init('/assets/afirma/miniapplet_1.7');
          this.xml = result['xml'];
          this.sign();
        },
        error => {
          this.errors = error;
        });
  }

  /**
   * Sign the form
   */
  sign() {
    document.getElementById('div_sign_error').innerText = '';
    afirma.sn = '';
    afirma.formulario = "firma";
    afirma.submit = "firma_submit";
    afirma.error = "div_sign_error";
    afirma.formularioweb = this.xml;
    afirma.prefix = 'firma';
    afirma.tipo_firma = 'XAdES';
    afirma.intentos_autofirma = 0;
    afirma.firmar(this.sign_submit, this.sign_error);
  }

  /**
   *
   * @param {string} signature
   */
  sign_submit = (signature: string) => {
    this.spinnerService.setSpinner(true);
    this.invoicingServiceService.saveInvoicingService(signature)
      .subscribe((invoicingService) => {
        this.translate.get("inv.createIS.createOKToast").subscribe((res: string) => {
          this.toastr.info(res).then();
        });
        this.myInvoicingServicesService.setNewInvoicingService(invoicingService);
        this.router.navigate(['empresas/' + this.person.identifier + '/plataformas']).then();
      }, error => {
        InvInvoicingServiceComponent.generateSignError(error.errors[0]);
      });
  };

  /**
   *
   * @param {string} error
   */
  sign_error = (error: string) => {
    InvInvoicingServiceComponent.generateSignError(error);
  };

  /**
   * Disable or not the button sign and save
   * @returns {boolean}
   */
  isDisabledSubmit(): boolean {
    return this.invoicingService.email === '' || !this.isAcceptedUseConditions;
  }

  onCancelClicked() {
    this.router.navigate(['/empresas']).then();
  }

  /**
   *
   * @param error
   */
  private static generateSignError(error) {
    let span = document.createElement('span');
    span.innerText = error;
    document.getElementById('div_sign_error').appendChild(span);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-invoicing-service/inv-invoicing-service.component.ts